<script>
import Swiper from "swiper";
// import Swiper styles
import "swiper/swiper-bundle.css";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper/core";
import Awards from "@/views/home/components/Awards.vue";
// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay]);
export default {
  name: "quem-somos",
  mounted() {
    this.start();
  },
  methods: {
    start() {
      setTimeout(() => {
        var swiper = new Swiper(this.$refs["mySwiper"], {
          slidesPerView: 1,
          spaceBetween: 0,
          navigation: {
            nextEl: this.$refs["swiper-button-next"],
            prevEl: this.$refs["swiper-button-prev"],
          },
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            768: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            1024: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
          },
        });
      }, 150);
      setTimeout(() => {
        var swiper3 = new Swiper(this.$refs["mySwiper2"], {
          slidesPerView: 1,
          spaceBetween: 0,
          navigation: {
            nextEl: this.$refs["swiper-button-next2"],
            prevEl: this.$refs["swiper-button-prev2"],
          },
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            768: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            1024: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
          },
        });
      }, 150);
      var swiper2 = new Swiper(this.$refs["mySwiper6"], {
        slidesPerView: 1,
        spaceBetween: 0,
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 0,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 0,
          },
        },
      });
    },
  },
  components: {
    Awards,
  },
};
</script>

<template>
  <div class="who-we-are">
    <section class="container who-we-are__box" id="quem-somos">
      <header>
        <h2>Quem somos</h2>
        <p>
          Gusmão & Labrunie é um dos melhores escritórios de Propriedade
          Intelectual do Brasil, com reconhecimento nacional e internacional na
          prestação de serviços jurídicos e técnicos com elevado padrão.
          <span class="space"></span> Com estrutura corporativa de
          aproximadamente 120 profissionais, entre advogados, especialistas em
          patentes e equipe administrativa, atendemos clientes dos mais variados
          portes, segmentos, e dentre eles algumas das principais empresas do
          mercado. <span class="space"></span>
          Nossa cultura promove e estimula o bom relacionamento, proporcionando
          a troca de experiências e aprendizado constante.
        </p>
      </header>
      <Awards class="awards-container" />
      <section class="who-we-are__gl">
        <div class="container">
          <header>
            <h2>Conheça mais Gusmão & Labrunie</h2>
          </header>
          <div class="swiper-container swiper mySwiper" ref="mySwiper2">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div>
                  <iframe
                    src="https://www.youtube.com/embed/R-2TuqDnksA"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
              
              <div class="swiper-slide">
                <div>
                  <iframe
                    src="https://www.youtube.com/embed/grXuQS9QM8c"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>

              <div class="swiper-slide">
                <div>
                  <iframe
                    src="https://www.youtube.com/embed/Ux4hmU6KWXQ"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>
            <div
              style="color: black"
              class="swiper-button-prev swiper-button-prev2"
              ref="swiper-button-prev2"
            ></div>
            <div
              style="color: black"
              class="swiper-button-next swiper-button-next2"
              ref="swiper-button-next2"
            ></div>
          </div>
        </div>
      </section>

      <div class="curiosity">
        <h2>Curiosidades em números</h2>
        <div class="row justify-content-center">
          <div class="col-4 col-lg-3">
            <img src="@/views/home/assets/images/30anos.svg" alt="" />
            <span> é a idade do(a) sócio(a) mais jovem do escritório </span>
          </div>
          <div class="col-4 col-lg-3">
            <img src="@/views/home/assets/images/porcentagem-mulheres.svg" width="120" alt="" />
            <span> do nosso quadro de colaboradores são mulheres </span>
          </div>
          <div class="col-4 col-lg-3">
            <img src="@/views/home/assets/images/tx-estag-90.svg" alt="" />
            <span>
              foi nossa taxa de efetivação de estagiários do último ano
            </span>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-4 col-lg-3">
            <img src="@/views/home/assets/images/20-a-35-anos.svg" alt="" />
            <span> do escritório são pessoas de 20 a 35 anos </span>
          </div>
          <div class="col-4 col-lg-3">
            <img src="@/views/home/assets/images/tempo-de-casa.svg" alt="" />
            <span>
              é o tempo de casa do colaborador com mais tempo no escritório
            </span>
          </div>
        </div>
      </div>
    </section>
    <section class="who-we-are__work">
      <div class="container">
        <header>
          <h2>Com o que trabalhamos</h2>
          <p>
            Nós trabalhamos para defender o que a humanidade faz de mais
            incrível: criar e inovar!
          </p>
        </header>
        <ul class="row">
          <li class="col-6 col-lg-2">
            <div class="d-flex">
              <img
                src="@/views/home/assets/images/AF_GusmãoLabrunie_Icones_brazilian-biodiversity.png"
                alt=""
              />
              <p>Biodiversidade Brasileira</p>
            </div>
          </li>
          <li class="col-6 col-lg-2">
            <div class="d-flex">
              <img
                src="@/views/home/assets/images/AF_GusmãoLabrunie_Icones_litigation-mediation-and-arbitration.png"
                alt=""
              />
              <p>Contencioso, Mediação e Arbitragem</p>
            </div>
          </li>
          <li class="col-6 col-lg-2">
            <div class="d-flex">
              <img
                src="@/views/home/assets/images/AF_GusmãoLabrunie_Icones_electronically-controlled-management-system.png"
                alt=""
              />
              <p>Contratos: Transferência de Tecnologia</p>
            </div>
          </li>
          <li class="col-6 col-lg-2">
            <div class="d-flex">
              <img
                src="@/views/home/assets/images/AF_GusmãoLabrunie_Icones_plant-varieties-cultivars.png"
                alt=""
              />
              <p>Cultivares</p>
            </div>
          </li>
          <li class="col-6 col-lg-2">
            <div class="d-flex">
              <img
                src="@/views/home/assets/images/AF_GusmãoLabrunie_Icones_industrial-designs.png"
                alt=""
              />
              <p>Desenho Industrial</p>
            </div>
          </li>
          <li class="col-6 col-lg-2">
            <div class="d-flex">
              <img
                src="@/views/home/assets/images/AF_GusmãoLabrunie_Icones_copyright.png"
                alt=""
              />
              <p>Direitos Autorais</p>
            </div>
          </li>
          <li class="col-6 col-lg-2">
            <div class="d-flex">
              <img
                src="@/views/home/assets/images/AF_GusmãoLabrunie_Icones_digital-law.png"
                alt=""
              />
              <p>Direito Digital</p>
            </div>
          </li>
          <li class="col-6 col-lg-2">
            <div class="d-flex">
              <img
                src="@/views/home/assets/images/AF_GusmãoLabrunie_Icones_franchises.png"
                alt=""
              />
              <p>Franquias</p>
            </div>
          </li>
          <li class="col-6 col-lg-2">
            <div class="d-flex">
              <img
                src="@/views/home/assets/images/AF_GusmãoLabrunie_Icones_entertainment-media-and-sports.png"
                alt=""
              />
              <p>Entretenimento, Mídia e Esportes</p>
            </div>
          </li>
          <li class="col-6 col-lg-2">
            <div class="d-flex">
              <img
                src="@/views/home/assets/images/AF_GusmãoLabrunie_Icones_fashion-law.png"
                alt=""
              />
              <p>Fashion Law</p>
            </div>
          </li>
          <li class="col-6 col-lg-2">
            <div class="d-flex">
              <img
                src="@/views/home/assets/images/AF_GusmãoLabrunie_Icones_legal-marketing.png"
                alt=""
              />
              <p>Legal Marketing</p>
            </div>
          </li>
          <li class="col-6 col-lg-2">
            <div class="d-flex">
              <img
                src="@/views/home/assets/images/AF_GusmãoLabrunie_Icones_innovation-law_2.png"
                alt=""
              />
              <p>Lei de Inovação</p>
            </div>
          </li>
          <li class="col-6 col-lg-2">
            <div class="d-flex">
              <img
                src="@/views/home/assets/images/AF_GusmãoLabrunie_Icones_trademarks_2.png"
                alt=""
              />
              <p>Marcas</p>
            </div>
          </li>
          <li class="col-6 col-lg-2">
            <div class="d-flex">
              <img
                src="@/views/home/assets/images/AF_GusmãoLabrunie_Icones_patents-.png"
                alt=""
              />
              <p>Patentes</p>
            </div>
          </li>
          <li class="col-6 col-lg-2">
            <div class="d-flex">
              <img
                src="@/views/home/assets/images/AF_GusmãoLabrunie_Icones_unfair-competition-business-secrets-and-confidential-information.png"
                alt=""
              />
              <p>Segredo de Negócio e Informações Confidenciais</p>
            </div>
          </li>
          <li class="col-6 col-lg-2">
            <div class="d-flex">
              <img
                src="@/views/home/assets/images/AF_GusmãoLabrunie_Icones_software.png"
                alt=""
              />
              <p>Software</p>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <section class="who-we-are__our-values">
      <div class="container mb-5">
        <header>
          <h2>Nossos Valores</h2>
        </header>

        <ul class="swiper-container swiper mySwiper6" ref="mySwiper6">
          <li class="swiper-wrapper">
            <div class="swiper-slide values">
              <img src="@/views/home/assets/images/rigor.png" alt="" />
              <h4>Rigor</h4>
              <span class="line"></span>
              <p>cuidado, atenção ao detalhe, excelência.</p>
            </div>
            <div class="swiper-slide values">
              <img src="@/views/home/assets/images/respeito.png" alt="" />
              <h4>Respeito</h4>
              <span class="line"></span>
              <p>
                qualquer trabalho é melhor executado em um ambiente amistoso,
                colaborativo e leve.
              </p>
            </div>
            <div class="swiper-slide values">
              <img src="@/views/home/assets/images/renovacao.png" alt="" />
              <h4>Renovação</h4>
              <span class="line"></span>
              <p>
                coragem para adotar novos hábitos, para corrigir o rumo e buscar
                alternativas pouco exploradas.
              </p>
            </div>
            <div class="swiper-slide values">
              <img src="@/views/home/assets/images/resultado.png" alt="" />
              <h4>Resultado</h4>
              <span class="line"></span>
              <p>
                é nossa reputação, satisfação do cliente, capacitação da equipe
                e desenvolvimento pessoal.
              </p>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <section class="who-we-are__works">
      <div class="container">
        <header>
          <h2>Conheça quem já trabalha aqui</h2>
        </header>
        
        <div class="swiper-container swiper mySwiper" ref="mySwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div>
                <iframe 
                  src="https://www.youtube.com/embed/rAK2RdO4UGM?si=l-TXzqL23jUB-PTD" 
                  title="YouTube video player" 
                  frameborder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                  referrerpolicy="strict-origin-when-cross-origin" 
                  allowfullscreen
                ></iframe>
              </div>
            </div>

            <div class="swiper-slide">
              <div>
                <iframe 
                  src="https://www.youtube.com/embed/qEpKu1ccu7o?si=xM2k_klCFG6YSb3_" 
                  title="YouTube video player" 
                  frameborder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                  referrerpolicy="strict-origin-when-cross-origin" 
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
          <div class="swiper-button-prev" ref="swiper-button-prev"></div>
          <div class="swiper-button-next" ref="swiper-button-next"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss">
.who-we-are {
  .swiper-button-prev,
  .swiper-button-next {
    color: #fff;
    border-radius: 100px;
    border: 1px solid #fff;
    width: 3rem;
    height: 3rem;
    &::after {
      font-size: 1.5rem;
    }
    @include media-breakpoint-down(md) {
      top: auto;
      bottom: 5px;
      left: 0 !important;
      right: 0 !important;
      margin: 0 auto;
      position: absolute;
      bottom: -10px;
      margin-bottom: 10px;
      border: 1px solid #212644;
      &::after {
        color: black;
      }
    }
  }
  .swiper-button-prev {
    transform: translateX(-25px);
    left: 40px;
    @include media-breakpoint-down(md) {
      position: relative;
    }
  }
  .swiper-button-next {
    transform: translateX(25px);
    right: 40px;
  }
  .swiper-button-prev2,
  .swiper-button-next2 {
    width: 3rem;
    height: 3rem;
    border: 1px solid #212644;
    border-radius: 100%;
    ::after {
      font-size: 1.3rem !important;
    }
    @include media-breakpoint-down(md) {
      top: auto;
      bottom: 5px;
      left: 0 !important;
      right: 0 !important;
      margin: 0 auto;
      position: absolute;
      bottom: -10px;
      margin-bottom: 10px;
    }
  }
  .swiper-button-prev2 {
    transform: translateX(-25px);
    left: 40px;
    @include media-breakpoint-down(md) {
      position: relative;
    }
  }
  .swiper-button-next2 {
    transform: translateX(25px);
    right: 40px;
  }
  .swiper {
    transform: translateY(80px);
  }
  .awards-container {
    max-width: 80%;
    margin: 0 auto;
    @include media-breakpoint-down(lg) {
      max-width: 80%;
    }
    @include media-breakpoint-down(sm) {
      max-width: 92%;
      p {
        font-size: 1.2rem;
      }
    }
  }
  .who-we-are__gl {
    height: 120%;
    .swiper-container {
      position: unset;
      min-height: 40rem;
      @include media-breakpoint-down(md) {
        min-height: fit-content;
      }
    }
    @include media-breakpoint-down(md) {
      margin-bottom: 8rem;
    }
    h2 {
      margin-top: 4rem !important;
      margin-bottom: 0rem !important;
    }
  }
}
</style>

<style lang="scss" scoped src="@/views/home/styles/whoWeAre.scss"></style>
